(function () {
  function localiseCpbContent() {
    var titleSource = document.getElementById('cpb-localised-title-source');
    var descriptionSource = document.getElementById('cpb-localised-description-source');

    var titleTarget = document.querySelector(
      '#product-builder .cpb-product-title'
    );

    var descriptionTarget = document.querySelector(
      '#product-builder .cpb-product-description'
    );

    var updated = false;

    // Localise product title
    if (titleSource && titleTarget) {
      var localisedTitle = titleSource.textContent.trim();

      if (
        localisedTitle &&
        titleTarget.textContent.trim() !== localisedTitle
      ) {
        titleTarget.textContent = localisedTitle;
      }

      updated = true;
    }

    // Localise product description
    if (descriptionSource && descriptionTarget) {
      var localisedDescription = descriptionSource.innerHTML.trim();

      if (
        localisedDescription &&
        descriptionTarget.innerHTML.trim() !== localisedDescription
      ) {
        descriptionTarget.innerHTML = localisedDescription;
      }

      updated = true;
    }

    return updated &&
      titleSource &&
      titleTarget &&
      descriptionSource &&
      descriptionTarget;
  }

  function start() {
    if (localiseCpbContent()) {
      return;
    }

    var attempts = 0;

    var timer = setInterval(function () {
      attempts++;

      if (localiseCpbContent() || attempts >= 30) {
        clearInterval(timer);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();